@if (product?.untypedFeatures) {
  <div class="TabBody">
    @for (feature of product?.ssgDocuments; track feature) {
      <div>
        @if (feature.code==product?.ssgDocName) {
          <div  class="row col-sm-12 Guidetextouter">
            <a class="Guidetext" [href]="feature.url" target="_blank">{{'common.pdp_technicalattribute_guide'| cxTranslate}}
            <img class="imgSize" [src]="'/icons/pdf-grey.svg'" alt="" /></a>
          </div>
        }
      </div>
    }
    @for (feature of product?.untypedFeatures; track feature) {
      <div>
        @if (feature.featureValues[0].value) {
          <div  class="row col-sm-12 bottom-border">
            <div class="col-xs-4 col-sm-4 col-md-4 label">{{ feature.description}}</div>
            <div class="col-xs-4 col-sm-4 col-md-4">{{ feature.featureValues[0].value }}&nbsp; {{feature?.featureUnitString}}</div>
          </div>
        }
      </div>
    }
  </div>
}